import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as ProjectsActions from './projects.actions';
import { ProjectsEntity } from './projects.models';
import { produce } from 'immer';
import { cloneDeep } from 'lodash';
import { indexRemapping } from '@piqet-angular/data';
import { keysToExclude } from '@piqet-angular/shared';

export const PROJECTS_FEATURE_KEY = 'projects';

export interface ProjectsState extends EntityState<ProjectsEntity> {
  myAllProjectsList: [] | any;
  myAllProductProjectsList: [] | any;
  newDefalutMaterialList: [] | any;
  myAllProjectsScenarioList: [] | any;
  myAllProjectsPackMaterialList: [] | any;
  myAllProjectsPackConversionList: [] | any;
  myAllProjectsScenarioConsumerList: [] | any;
  myAllProjectsScenarioReatilList: [] | any;
  myAllProjectsScenarioWholesaleList: [] | any;
  transportScenarioList: [] | any;
  transportScenarioListForDistance: [] | any;
  customTransoportScenarioDetailViewModels: [] | any;
  transportScenarioListForDistancePackRetail: [] | any;
  transportScenarioListForRetail: [] | any;
  transportScenarioEolDataListForRetail: [] | any;
  resetEolList: [] | any;
  conversionList: [] | any;
  fillingList: [] | any;
  fillingProcessList: [] | any;
  locationList: [] | any;
  distanceList: [] | any;
  locationListProduct: [] | any;
  distanceProductList: [] | any;
  freightList: [] | any;
  componentList: [] | any;
  productList: [] | any;
  projectsFillingList: [] | any;
  eolTotalError: any;
  freightProductList: [] | any;
  wholesaleList: [] | any;
  productIngredientList: [] | any;
  locationWholesaleList: [] | any;
  distanceWholesaleList: [] | any;
  freightWholesaleList: [] | any;
  replicaLocation: [] | any;
  replicaDistance: [] | any;
  ingredientItems: [] | any;
  organizationItems: [] | any;
  organizationPreferencesItems: [] | any;
  ingredientTransportList: [] | any;
  storeerr: [] | any;
  porductIngredientDistance: [] | any;
  getManufacturProcessList: [] | any;
  productManufactureList: [] | any;
  productIngredientistanceProcessList: [] | any;
  newDefalutOrgReportingList: [] | any;
  eolResueList: [] | any;
  eolConsumerList: [] | any;
  errorMsgForComponent: [] | any;
  errorMsgForReuseEOL: [] | any;
  errorMessageForProductIngredient: string | null;
  projectName: string | null;
  eolPreRetailData: [] | any;
  transportScenarioManualLocationList: [] | any;
  transportScenarioManualDistanceList: [] | any;
  componentPreRetailList: [] | any;
  preRetailReuseActionList: [] | any;
  duplicateManualLocation: [] | any;
  duplicateManualDistance: [] | any;
  dupliatePreRetailActionList: [] | any;
  orgReportingErrorState: '' | any;
  packEOLRetailList: [] | any;
  packEOLConsumerList: [] | any;
  productMixProcess: [] | any;
  productMixProcessError: '' | any;
  distanceErrorProject: '' | any;
  distanceErrorProjectProduct: '' | any;
  checkUpdateActionProdMix: boolean;
  checkUpdateActionForOrganizationMapping: boolean;
  checkUpdateActionInterpretation: boolean;
  checkUpdateActionIngredient: boolean;
  dataAnalysisTechnology: [] | any;
  checkUpdateActionForReuse: boolean;
}

export interface ProjectsPartialState {
  readonly [PROJECTS_FEATURE_KEY]: ProjectsState;
}

function validationMessage(filteredData: any, typeName: any, typeId: any) {
  const processRequired = filteredData.filter((data: any) => data[typeName] == 'Select a product')
    .length
    ? true
    : false;
  const unitsRequired = filteredData.filter((data: any) => !data?.ratio).length ? true : false;
  const error = processRequired
    ? 'Please fill all the mandatory information to proceed further in the process. '
    : unitsRequired
    ? 'Please enter ratio'
    : '';
  return error;
}

export const projectsAdapter: EntityAdapter<ProjectsEntity> = createEntityAdapter<ProjectsEntity>();

export const initialProjectsState: ProjectsState = projectsAdapter.getInitialState({
  myAllProjectsList: [],
  myAllProductProjectsList: [],
  newDefalutMaterialList: [],
  myAllProjectsScenarioList: [],
  myAllProjectsScenarioConsumerList: [],
  myAllProjectsScenarioReatilList: [],
  myAllProjectsPackMaterialList: [],
  myAllProjectsPackConversionList: [],
  myAllProjectsScenarioWholesaleList: [],
  transportScenarioList: [],
  transportScenarioListForRetail: [],
  transportScenarioEolDataListForRetail: [],
  resetEolList: [],
  transportScenarioListForDistance: [],
  conversionList: [],
  fillingList: [],
  fillingProcessList: [],
  customTransoportScenarioDetailViewModels: [],
  transportScenarioListForDistancePackRetail: [],
  locationList: [],
  distanceList: [],
  freightList: [],
  componentList: [],
  productList: [],
  projectsFillingList: [],
  eolTotalError: {},
  locationListProduct: [],
  distanceProductList: [],
  freightProductList: [],
  wholesaleList: [],
  locationWholesaleList: [],
  distanceWholesaleList: [],
  freightWholesaleList: [],
  replicaLocation: [],
  replicaDistance: [],
  productIngredientList: [],
  errorMsgForComponent: [],
  errorMsgForReuseEOL: [],
  ingredientItems: [],
  organizationItems: [],
  organizationPreferencesItems: [],
  ingredientTransportList: [],
  storeerr: [],
  getManufacturProcessList: [],
  productManufactureList: [],
  porductIngredientDistance: [],
  productIngredientistanceProcessList: [],
  newDefalutOrgReportingList: [],
  errorMessageForProductIngredient: '',
  projectName: '',
  eolResueList: [],
  eolConsumerList: [],
  eolPreRetailData: [],
  transportScenarioManualLocationList: [],
  transportScenarioManualDistanceList: [],
  componentPreRetailList: [],
  preRetailReuseActionList: [],
  duplicateManualLocation: [],
  duplicateManualDistance: [],
  dupliatePreRetailActionList: [],
  orgReportingErrorState: '',
  packEOLRetailList: [],
  packEOLConsumerList: [],
  productMixProcess: [],
  productMixProcessError: '',
  distanceErrorProject: '',
  distanceErrorProjectProduct: '',
  checkUpdateActionProdMix: false,
  checkUpdateActionForOrganizationMapping: false,
  checkUpdateActionInterpretation: false,
  checkUpdateActionIngredient: false,
  dataAnalysisTechnology: [],
  checkUpdateActionForReuse: false,
});

const reducer = createReducer(
  initialProjectsState,
  //get My All projects Reducers
  on(ProjectsActions.getAllMyProjectList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(ProjectsActions.getAllMyProjectListSuccess, (state, { myAllProjectsList }) => {
    return { ...state, myAllProjectsList: myAllProjectsList, loaded: true };
  }),
  on(ProjectsActions.getAllMyProjectListFailure, (state, { error }) => ({ ...state, error })),
  //get My All product projects Reducers
  on(ProjectsActions.getProductIngredientList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(ProjectsActions.getProductIngredientListSuccess, (state, { productIngredientList }) => {
    return { ...state, productIngredientList: productIngredientList, loaded: true };
  }),
  on(ProjectsActions.getProductIngredientListFailure, (state, { error }) => ({ ...state, error })),
  //get My All product projects product manufacture
  on(ProjectsActions.getProductManufactureList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(ProjectsActions.getProductManufactureListSuccess, (state, { productManufactureList }) => {
    return { ...state, productManufactureList: productManufactureList, loaded: true };
  }),
  on(ProjectsActions.getProductManufactureListFailure, (state, { error }) => ({ ...state, error })),
  //get My All projects Reducers
  on(ProjectsActions.getAllMyProductProjectList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(ProjectsActions.getAllMyProductProjectListSuccess, (state, { myAllProductProjectsList }) => {
    return { ...state, myAllProductProjectsList: myAllProductProjectsList, loaded: true };
  }),
  on(ProjectsActions.getAllMyProductProjectListFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  //get My All projects Reducers
  on(ProjectsActions.getAllMyProjectScenarioList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(ProjectsActions.getAllMyProjectScenarioListSuccess, (state, { myAllProjectsScenarioList }) => {
    return { ...state, myAllProjectsScenarioList: myAllProjectsScenarioList, loaded: true };
  }),
  on(ProjectsActions.getAllMyProjectScenarioListFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  //get My All projects pack material
  on(ProjectsActions.getAllMyProjectPackMaterialList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(
    ProjectsActions.getAllMyProjectPackMaterialListSuccess,
    (state, { myAllProjectsPackMaterialList }) => {
      if (!myAllProjectsPackMaterialList.isCostTurnOff) {
        const componentList = myAllProjectsPackMaterialList.componentList.data;
        const sum = myAllProjectsPackMaterialList.componentList.data.map((x: any) => {
          return (x.materialWeight / 100) * x.materialCost;
        });
        const result = componentList.map((obj: any, index: any) => ({
          ...obj,
          cost: sum[index],
        }));
        const setObject = {
          data: result,
          draw: myAllProjectsPackMaterialList.componentList.draw,
          recordsFiltered: myAllProjectsPackMaterialList.componentList.recordsFiltered,
          recordsTotal: myAllProjectsPackMaterialList.componentList.recordsTotal,
        };
        var object: any = {};
        object['componentList'] = setObject;
        object['isCostTurnOff'] = myAllProjectsPackMaterialList.isCostTurnOff;
        object['isLockProject'] = myAllProjectsPackMaterialList.isLockProject;
      }
      return {
        ...state,
        myAllProjectsPackMaterialList: object || myAllProjectsPackMaterialList,
        loaded: true,
      };
    }
  ),
  on(ProjectsActions.getAllMyProjectPackMaterialListFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  //get My All projects pack conversion
  on(ProjectsActions.getAllMyProjectPackConversionList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(
    ProjectsActions.getAllMyProjectPackConversionListSuccess,
    (state, { myAllProjectsPackConversionList }) => {
      return {
        ...state,
        myAllProjectsPackConversionList: myAllProjectsPackConversionList,
        loaded: true,
      };
    }
  ),
  on(ProjectsActions.getAllMyProjectPackConversionListFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  //get My All projects scenario consumer Reducers
  on(ProjectsActions.getAllMyProjectScenarioConsumerList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(
    ProjectsActions.getAllMyProjectScenarioConsumerListSuccess,
    (state, { myAllProjectsScenarioConsumerList }) => {
      return {
        ...state,
        myAllProjectsScenarioConsumerList: myAllProjectsScenarioConsumerList,
        loaded: true,
      };
    }
  ),
  on(ProjectsActions.getAllMyProjectScenarioConsumerListFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  //get My All projects scenario reatil Reducers
  on(ProjectsActions.getAllMyProjectScenarioRetailList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(
    ProjectsActions.getAllMyProjectScenarioRetailListSuccess,
    (state, { myAllProjectsScenarioReatilList }) => {
      return {
        ...state,
        myAllProjectsScenarioReatilList: myAllProjectsScenarioReatilList,
        loaded: true,
      };
    }
  ),
  on(ProjectsActions.getAllMyProjectScenarioRetailListFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  //get My All projects scenario reatil Reducers
  on(ProjectsActions.getAllMyProjectScenarioWholesaleList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(
    ProjectsActions.getAllMyProjectScenarioWholesaleListSuccess,
    (state, { myAllProjectsScenarioWholesaleList }) => {
      return {
        ...state,
        myAllProjectsScenarioWholesaleList: myAllProjectsScenarioWholesaleList,
        loaded: true,
      };
    }
  ),
  on(ProjectsActions.getAllMyProjectScenarioWholesaleListFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  //reducer for default in new add project
  on(ProjectsActions.newMyProjectAction, state => {
    return { ...state, error: null };
  }),
  on(ProjectsActions.newMyProjectActionSuccess, (state, { newDefalutMaterialList }) => {
    return { ...state, newDefalutMaterialList: newDefalutMaterialList };
  }),
  on(ProjectsActions.newMyProjectActionFailure, (state, { error }) => {
    return { ...state, error };
  }),
  on(ProjectsActions.clearNewMyProjectAction, state => {
    return { ...state, newDefalutMaterialList: [] };
  }),
  on(ProjectsActions.addTransportScenarioForPackMaterial, state => {
    return { ...state, error: null };
  }),
  on(
    ProjectsActions.openAllMyProjectScenarioModalSuccess,
    (state, { openAllMyProjectScenarioModalData }) => {
      return {
        ...state,
        transportScenarioList:
          openAllMyProjectScenarioModalData.data.customTransportScenarioDetails,
      };
    }
  ),

  on(
    ProjectsActions.addTransportScenarioForPackMaterialSuccess,
    (state, { transportScenarioList, error, distanceError }) => {
      return {
        ...state,
        transportScenarioList: transportScenarioList,
        error: error,
        distanceErrorProject: distanceError,
      };
    }
  ),
  on(
    ProjectsActions.addTransportScenarioForDistancePackMaterialSuccess,
    (state, { transportScenarioListForDistance, error }) => {
      return {
        ...state,
        transportScenarioListForDistance: transportScenarioListForDistance,
        error: error,
      };
    }
  ),

  on(ProjectsActions.addPackMaterialConversionSuccess, (state, { conversionList, error }) => {
    return { ...state, conversionList: conversionList, error: error };
  }),

  on(
    ProjectsActions.openNewAddProjectMaterialModalSuccess,
    (state, { openNewAddProjectMaterialModalData }) => {
      return {
        ...state,
        transportScenarioList: openNewAddProjectMaterialModalData.data.locationTransportationItems,
        transportScenarioListForDistance:
          openNewAddProjectMaterialModalData.data.distanceTransportationItems,
        conversionList: openNewAddProjectMaterialModalData.data.conversionProcessItems,
        customTransoportScenarioDetailViewModels:
          openNewAddProjectMaterialModalData.data.customTransoportScenarioDetailViewModels,
      };
    }
  ),
  on(ProjectsActions.clearaddTransportScenarioForPackMaterialForCustom, state => {
    return { ...state, customTransoportScenarioDetailViewModels: [] };
  }),
  on(ProjectsActions.clearaddTransportScenarioForPackMaterialForConversion, state => {
    return { ...state, conversionList: [], distanceErrorProject: '' };
  }),
  on(ProjectsActions.clearManualTransportDistanceError, state => {
    return { ...state, distanceErrorProjectProduct: '' };
  }),
  on(ProjectsActions.clearaddTransportScenarioForPackMaterial, state => {
    return {
      ...state,
      transportScenarioList: [],
      transportScenarioListForDistance: [],
      customTransportScenarioError: null,
      transportFinalGrid: [],
      error: null,
      customTransoportScenarioDetailViewModels: [],
    };
  }),

  //open modal data pack retail
  on(
    ProjectsActions.openNewAddProjectRetaiModalSuccess,
    (state, { openNewAddProjectRetailModalData }) => {
      let locationListProduct;
      let distanceProductList;
      let customProductList;
      if (openNewAddProjectRetailModalData.data?.transportationId == 2) {
        locationListProduct = openNewAddProjectRetailModalData.data.locationTransportationItems;
        distanceProductList = [];
        customProductList = [];
      } else if (openNewAddProjectRetailModalData.data?.transportationId == 3) {
        distanceProductList = openNewAddProjectRetailModalData.data.distanceTransportationItems;
        locationListProduct = [];
        customProductList = [];
      } else {
        locationListProduct = [];
        distanceProductList = [];
        customProductList =
          openNewAddProjectRetailModalData.data.customTransoportScenarioDetailViewModels;
      }
      return {
        ...state,
        transportScenarioListForRetail: locationListProduct,
        transportScenarioListForDistancePackRetail: distanceProductList,
        transportScenarioEolDataListForRetail:
          openNewAddProjectRetailModalData.data.eOLListViewModels,
        resetEolList: openNewAddProjectRetailModalData.data.eOLListViewModels,
        customTransoportScenarioDetailViewModels: customProductList,
      };
    }
  ),

  on(ProjectsActions.addEolViewModalData, (state, { EOLviewData }) => {
    EOLviewData = EOLviewData.map((item: any, index: any) => {
      return {
        ...item,
        index: index + 1,
      };
    });
    return {
      ...state,
      transportScenarioEolDataListForRetail: EOLviewData,
      resetEolList: EOLviewData,
    };
  }),

  on(ProjectsActions.addEolViewModalDataChange, (state, { resetEOLviewData }) => {
    resetEOLviewData = resetEOLviewData.map((item: any, index: any) => {
      return {
        ...item,
        index: index + 1,
      };
    });
    return { ...state, transportScenarioEolDataListForRetail: resetEOLviewData };
  }),

  on(ProjectsActions.clearaddTransportScenarioForPackRetail, state => {
    return {
      ...state,
      transportScenarioListForRetail: [],
      transportScenarioListForDistancePackRetail: [],
      customTransportScenarioError: null,
      transportFinalGrid: [],
      error: null,
      customTransoportScenarioDetailViewModels: [],
    };
  }),
  on(ProjectsActions.clearaddTransportScenarioForPackRetailForCustom, state => {
    return {
      ...state,
      customTransoportScenarioDetailViewModels: [],
      transportScenarioListForDistancePackRetail: [],
    };
  }),
  on(ProjectsActions.addPackRetailEolSuccess, (state, { retailEolList, error }) => {
    return { ...state, transportScenarioEolDataListForRetail: retailEolList, eolTotalError: error };
  }),
  on(ProjectsActions.clearTotalEolMessage, state => {
    return { ...state, eolTotalError: [] };
  }),
  on(
    ProjectsActions.addTransportScenarioForPackRetailSuccess,
    (state, { transportScenarioManualLocationList, error, distanceError }) => {
      return {
        ...state,
        transportScenarioListForRetail: transportScenarioManualLocationList,
        error: error,
        distanceErrorProject: distanceError,
      };
    }
  ),
  on(
    ProjectsActions.addTransportScenarioForDistancePackRetailSuccess,
    (state, { retailTransportScenarioListForDistance, error }) => {
      return {
        ...state,
        transportScenarioListForDistancePackRetail: retailTransportScenarioListForDistance,
        error: error,
      };
    }
  ),

  // Action for Project Filling Data
  on(ProjectsActions.getProjectFillingList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(ProjectsActions.getProjectFillingListSuccess, (state, { fillingList }) => {
    return { ...state, fillingList: fillingList, loaded: true };
  }),
  on(ProjectsActions.getProjectFillingListFailure, (state, { error }) => ({ ...state, error })),

  // Action for Project eol resue Data
  on(ProjectsActions.projectEOLReuseList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(ProjectsActions.projectEOLReuseListSuccess, (state, { eolResueList }) => {
    return { ...state, eolResueList: eolResueList, loaded: true };
  }),
  on(ProjectsActions.projectEOLReuseListFailure, (state, { error }) => ({ ...state, error })),
  // Action for Project eol resue Data
  on(ProjectsActions.projectEOLConsumerist, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(ProjectsActions.projectEOLConsumeristSuccess, (state, { eolConsumerList }) => {
    return { ...state, eolConsumerList: eolConsumerList, loaded: true };
  }),
  on(ProjectsActions.projectEOLConsumeristFailure, (state, { error }) => ({ ...state, error })),

  on(ProjectsActions.addFillingProcess, state => {
    return { ...state, error: null };
  }),
  on(ProjectsActions.addFillingProcessSuccess, (state, { fillingList, error }) => {
    return { ...state, fillingProcessList: fillingList, error: error };
  }),
  on(ProjectsActions.clearaddFillingProcess, state => {
    return { ...state, fillingProcessList: [], error: null };
  }),

  on(ProjectsActions.openNewAddProjectFillDataSuccess, (state, { addEditFillingModalData }) => {
    const isEditCompList = addEditFillingModalData.data.fillingTempDatalistIteams.map((x: any) => {
      return { ...x, isEdit: true };
    });
    let locationListProduct;
    let distanceProductList;
    let customProductList;
    if (addEditFillingModalData.data?.productTransportaionId == 2) {
      locationListProduct = addEditFillingModalData.data.productLocationTransportationItems;
      distanceProductList = [];
      customProductList = [];
    } else if (addEditFillingModalData.data?.productTransportaionId == 3) {
      distanceProductList = addEditFillingModalData.data.productDistanceTransportationItems;
      locationListProduct = [];
      customProductList = [];
    } else {
      locationListProduct = [];
      distanceProductList = [];
      customProductList = addEditFillingModalData.data.productTransportScenarioDetails;
    }
    return {
      ...state,
      fillingProcessList: addEditFillingModalData.data.fillingProcessItems,
      componentList: isEditCompList,
      locationListProduct: locationListProduct,
      distanceProductList: distanceProductList,
      freightProductList: customProductList,
      productList: addEditFillingModalData.data.productTransportationItems,
    };
  }),
  // for adding transport scenario location -> Filling
  on(ProjectsActions.addLocationProcess, state => {
    return { ...state, error: null };
  }),
  on(
    ProjectsActions.addLocationProcessSuccess,
    (state, { locationList, replicaLocation, error, distanceError }) => {
      return {
        ...state,
        locationList: locationList,
        replicaLocation: replicaLocation,
        error: error,
        distanceErrorProject: distanceError,
      };
    }
  ),
  // for adding ingredinet
  on(ProjectsActions.addLocationProcessIngredient, state => {
    return { ...state, error: null };
  }),
  on(
    ProjectsActions.addLocationProcessIngredientSuccess,
    (state, { locationList, replicaLocation, error, distanceError }) => {
      return {
        ...state,
        locationList: locationList,
        replicaLocation: replicaLocation,
        error: error,
        distanceErrorProject: distanceError,
      };
    }
  ),
  on(ProjectsActions.clearLocationProcess, state => {
    return {
      ...state,
      transportScenarioList: [],
      locationList: [],
      transportScenarioManualLocationList: [],
      error: null,
    };
  }),
  on(ProjectsActions.clearAllReplicaList, state => {
    return { ...state, replicaLocation: [], replicaDistance: [], error: null };
  }),
  // for product
  on(ProjectsActions.addLocationProcessProduct, state => {
    return { ...state, error: null };
  }),
  on(
    ProjectsActions.addLocationProcessProductSuccess,
    (state, { locationProductList, error, distanceError }) => {
      return {
        ...state,
        locationListProduct: locationProductList,
        error: error,
        distanceErrorProjectProduct: distanceError,
      };
    }
  ),
  on(ProjectsActions.clearaddLocationProcessProduct, state => {
    return { ...state, locationListProduct: [], error: null };
  }),
  //Distance transport
  on(ProjectsActions.addDistanceTransport, state => {
    return { ...state, error: null };
  }),
  on(
    ProjectsActions.addDistanceTransportSuccess,
    (state, { distanceList, replicaDistanceList, productIngredientistanceProcessList, error }) => {
      return {
        ...state,
        distanceList: distanceList,
        replicaDistance: replicaDistanceList,
        productIngredientistanceProcessList: productIngredientistanceProcessList,
        error: error,
      };
    }
  ),
  //Distance transport for product ingredient
  on(ProjectsActions.addDistanceTransportIngredeint, state => {
    return { ...state, error: null };
  }),
  on(
    ProjectsActions.addDistanceTransportIngredeintSuccess,
    (state, { distanceList, replicaDistanceList, productIngredientistanceProcessList, error }) => {
      return {
        ...state,
        distanceList: distanceList,
        replicaDistance: replicaDistanceList,
        productIngredientistanceProcessList: productIngredientistanceProcessList,
        error: error,
      };
    }
  ),
  on(ProjectsActions.clearaddDistanceTransport, state => {
    return {
      ...state,
      distanceList: [],
      distanceProductList: [],
      transportScenarioListForDistance: [],
      transportScenarioManualDistanceList: [],
      error: null,
    };
  }),
  on(ProjectsActions.clearaddDistanceProductTransport, state => {
    return { ...state, distanceProductList: [], error: null };
  }),
  // for product
  on(ProjectsActions.addDistanceTransportProduct, state => {
    return { ...state, error: null };
  }),
  on(
    ProjectsActions.addDistanceTransportProductSuccess,
    (state, { distanceProductList, error }) => {
      return { ...state, distanceProductList: distanceProductList, error: error };
    }
  ),
  // custom freight
  on(ProjectsActions.getCustomFreight, state => {
    return { ...state, error: null };
  }),
  on(ProjectsActions.getCustomFreightSuccess, (state, { freightList }) => {
    return { ...state, freightList: freightList };
  }),
  on(ProjectsActions.clearCustomFreight, state => {
    return { ...state, freightList: [], customTransoportScenarioDetailViewModels: [], error: null };
  }),
  // component transport
  on(ProjectsActions.addComponent, state => {
    return { ...state, error: null };
  }),
  on(ProjectsActions.addComponentSuccess, (state, { componentList, error }) => {
    return { ...state, componentList: componentList, errorMsgForComponent: error };
  }),
  on(ProjectsActions.clearComponent, state => {
    return { ...state, componentList: [], productList: [], error: null };
  }),
  // product transport
  on(ProjectsActions.addProduct, state => {
    return { ...state, error: null };
  }),
  on(ProjectsActions.addProductSuccess, (state, { productList, storeerr }) => {
    return { ...state, productList: productList, storeerr: storeerr };
  }),
  on(ProjectsActions.clearProduct, state => {
    return { ...state, productList: [], error: null };
  }),

  on(ProjectsActions.getCustomFreightProduct, state => {
    return { ...state, error: null };
  }),
  on(ProjectsActions.getCustomFreightProductSuccess, (state, { freightProductList }) => {
    return { ...state, freightProductList: freightProductList };
  }),
  on(ProjectsActions.clearCustomFreightProduct, state => {
    return { ...state, freightProductList: [], error: null };
  }),

  // For wholesale location
  on(ProjectsActions.addLocationWholesale, state => {
    return { ...state, error: null };
  }),
  on(
    ProjectsActions.addLocationWholesaleSuccess,
    (state, { locationWholesaleList, error, distanceError }) => {
      return {
        ...state,
        locationWholesaleList: locationWholesaleList,
        error: error,
        distanceErrorProject: distanceError,
      };
    }
  ),
  on(ProjectsActions.clearaddLocationWholesale, state => {
    return { ...state, locationWholesaleList: [], error: null };
  }),

  // For wholesale distance
  on(ProjectsActions.addDistanceWholesale, state => {
    return { ...state, error: null };
  }),
  on(ProjectsActions.addDistanceWholesaleSuccess, (state, { wholesaleDistanceList, error }) => {
    return { ...state, distanceWholesaleList: wholesaleDistanceList, error: error };
  }),
  on(ProjectsActions.clearaddDistanceWholesale, state => {
    return { ...state, distanceWholesaleList: [], error: null };
  }),

  on(ProjectsActions.getCustomFreightWholesale, state => {
    return { ...state, error: null };
  }),
  on(ProjectsActions.getCustomFreightWholesaleSuccess, (state, { freightWholesaleList }) => {
    return { ...state, freightWholesaleList: freightWholesaleList };
  }),
  on(ProjectsActions.clearCustomFreightWholesale, state => {
    return { ...state, freightWholesaleList: [], error: null };
  }),

  on(
    ProjectsActions.openNewAddProjectWholesaleDataSuccess,
    (state, { addEditWholesaleModalData }) => {
      let distanceListEdit = addEditWholesaleModalData.data.distanceTransportationItems.map(
        (x: any) => {
          return { ...x, isDistance: true };
        }
      );
      let locationListProduct;
      let distanceProductList;
      let customProductList;
      if (addEditWholesaleModalData.data?.transportationId == 2) {
        locationListProduct = addEditWholesaleModalData.data.locationTransportationItems;
        distanceProductList = [];
        customProductList = [];
      } else if (addEditWholesaleModalData.data?.transportationId == 3) {
        distanceProductList = distanceListEdit;
        locationListProduct = [];
        customProductList = [];
      } else {
        locationListProduct = [];
        distanceProductList = [];
        customProductList = addEditWholesaleModalData.data.customTransoportScenarioDetailViewModels;
      }
      return {
        ...state,
        locationWholesaleList: locationListProduct,
        distanceWholesaleList: distanceProductList,
        freightWholesaleList: customProductList,
      };
    }
  ),
  on(
    ProjectsActions.openModalProductIngredientModalSuccess,
    (state, { openModalProductIngredientModalData }) => {
      return {
        ...state,
        ingredientItems: openModalProductIngredientModalData.data.productIngredientItems,
        getManufacturProcessList: openModalProductIngredientModalData.data.fillingProcessItems,
        ingredientTransportList: openModalProductIngredientModalData.data.productData,
      };
    }
  ),
  on(
    ProjectsActions.proudctIngredientProcessSuccess,
    (state, { ingredientItems, errorMessage }) => {
      return {
        ...state,
        ingredientItems: ingredientItems,
        errorMessageForProductIngredient: errorMessage,
      };
    }
  ),

  on(
    ProjectsActions.organizationDataMapProcessSuccess,
    (state, { organizationItems, errorMessage }) => {
      return {
        ...state,
        organizationItems: organizationItems,
        errorMessageForProductIngredient: errorMessage,
      };
    }
  ),

  on(
    ProjectsActions.organizationPreferencesDataMapProcessSuccess,
    (state, { organizationItems, errorMessage }) => {
      return {
        ...state,
        organizationPreferencesItems: organizationItems,
        errorMessageForProductIngredient: errorMessage,
      };
    }
  ),
  on(ProjectsActions.getOrganizationDataMap, (state, { organizationMapList }) => {
    return {
      ...state,
      organizationItems: organizationMapList,
    };
  }),
  on(
    ProjectsActions.getOrganizationPreferencesDataMap,
    (state, { organizationPreferencesMapList }) => {
      return {
        ...state,
        organizationPreferencesItems: organizationPreferencesMapList,
      };
    }
  ),
  on(ProjectsActions.proudctIngredientProcessFailure, (state, { error }) => {
    return {
      ...state,
      errorMessageForProductIngredient: error,
    };
  }),
  on(
    ProjectsActions.proudctIngredientTransportProcessSuccess,
    (state, { ingredientTransportList, errorMessage }) => {
      return {
        ...state,
        ingredientTransportList: ingredientTransportList,
        errorMessageForProductIngredient: errorMessage,
      };
    }
  ),
  on(
    ProjectsActions.proudctIngredientManufactureProcessSuccess,
    (state, { getManufacturProcessList }) => {
      return {
        ...state,
        getManufacturProcessList: getManufacturProcessList,
      };
    }
  ),
  on(ProjectsActions.clearProudctIngredientProcess, state => {
    return {
      ...state,
      replicaDistance: [],
      replicalocation: [],
      ingredientItems: [],
      errorMessageForProductIngredient: '',
      getManufacturProcessList: [],
    };
  }),
  on(ProjectsActions.clearProudctIngredientProcessError, state => {
    return { ...state, errorMessageForProductIngredient: '' };
  }),
  on(ProjectsActions.projectNameForBreadCrumbs, state => {
    return { ...state };
  }),
  on(ProjectsActions.projectNameForBreadCrumbsSuccess, (state, { projectName }) => {
    return { ...state, projectName: projectName };
  }),
  on(ProjectsActions.clearProjectNameForBreadCrumbs, state => {
    return { ...state, projectName: '' };
  }),
  on(ProjectsActions.fillOrgYearGridData, (state, { data }) => {
    const mappedData = data.map((item: any, i: any) => ({
      ...item,
      index: i,
    }));
    return { ...state, newDefalutOrgReportingList: mappedData };
  }),
  on(ProjectsActions.newMyProjectOrgReportingSuccess, (state, { newDefalutOrgReportingList }) => {
    return { ...state, newDefalutOrgReportingList: newDefalutOrgReportingList };
  }),
  on(ProjectsActions.newMyProjectOrgReportingFailure, (state, { error }) => {
    return { ...state, error };
  }),
  on(ProjectsActions.clearMyProjectOrgReporting, state => {
    return { ...state, newDefalutOrgReportingList: [] };
  }),

  //open pre retail modal
  on(ProjectsActions.openAddEditEolPreRetailSuccess, (state, { eolPreRetailData }) => {
    return {
      ...state,
      eolPreRetailData: eolPreRetailData.data,
      componentPreRetailList: eolPreRetailData.data.addReuseFillingDatalistIteams,
      duplicateManualDistance: eolPreRetailData.data.distanceTransportationItems,
      duplicateManualLocation: eolPreRetailData.data.locationTransportationItems,
      dupliatePreRetailActionList: eolPreRetailData.data.distanceTransportationItems,
    };
  }),
  // transport pre retail
  on(ProjectsActions.clearEolPreReatil, (state, { resetText }) => {
    return {
      ...state,
      transportScenarioManualLocationList: [],
      eolPreRetailData: [],
      transportScenarioManualDistanceList: [],
      preRetailReuseActionList: [],
      componentPreRetailList: resetText === 'resetData' ? state.componentPreRetailList : [],
      errorMsgForComponent: '',
      freightList: [],
    };
  }),
  on(ProjectsActions.clearFillDataComponentErr, state => {
    return { ...state, errorMsgForComponent: '' };
  }),
  on(ProjectsActions.clearFillDataProductErr, state => {
    return { ...state, storeerr: '' };
  }),
  on(ProjectsActions.clearPreRetailReuseActionList, state => {
    return { ...state, preRetailReuseActionList: [] };
  }),
  on(
    ProjectsActions.manudaLocationPreRetailSuccess,
    (
      state,
      { transportScenarioManualLocationList, duplicateManualLocation, error, distanceError }
    ) => {
      return {
        ...state,
        transportScenarioManualLocationList: transportScenarioManualLocationList,
        duplicateManualLocation: duplicateManualLocation,
        error: error,
        distanceErrorProject: distanceError,
      };
    }
  ),
  on(
    ProjectsActions.manudaDistancePreRetailSuccess,
    (state, { transportScenarioManualDistanceList, duplicateManualDistance, error }) => {
      return {
        ...state,
        transportScenarioManualDistanceList: transportScenarioManualDistanceList,
        duplicateManualDistance: duplicateManualDistance,
        error: error,
      };
    }
  ),
  on(
    ProjectsActions.preRetailReuseActionSuccess,
    (state, { preRetailReuseActionList, dupliatePreRetailActionList }) => {
      return {
        ...state,
        preRetailReuseActionList: preRetailReuseActionList,
        dupliatePreRetailActionList: dupliatePreRetailActionList,
      };
    }
  ),
  on(
    ProjectsActions.preRetailReuseSetData,
    (state, { preRetailReuseActionList, transportId, transportData }) => {
      // Conditional binding based on transportId
      let updatedState = { ...state, preRetailReuseActionList: preRetailReuseActionList };

      if (transportId == 3) {
        updatedState = {
          ...updatedState,
          transportScenarioManualDistanceList: transportData,
        };
      } else if (transportId == 2) {
        updatedState = {
          ...updatedState,
          transportScenarioManualLocationList: transportData,
        };
      } else if (transportId == 4) {
        updatedState = {
          ...updatedState,
          freightList: transportData,
        };
      }
      return updatedState;
    }
  ),
  // pre retail  component transport
  on(ProjectsActions.eolPreRetailAddComponent, state => {
    return { ...state, error: null };
  }),
  on(
    ProjectsActions.eolPreRetailAddComponentSuccess,
    (state, { componentPreRetailList, error }) => {
      const indexedList = componentPreRetailList.map((x: any, idx: any) => {
        return { ...x, index: idx + 1 };
      });
      return { ...state, componentPreRetailList: indexedList, errorMsgForComponent: error };
    }
  ),
  on(ProjectsActions.clearEolPreRetailAddComponent, state => {
    return { ...state, componentPreRetailList: [], error: null };
  }),

  on(ProjectsActions.addOrgYear, (state, { process, action }) => {
    process = cloneDeep(process);
    process['index'] = state.newDefalutOrgReportingList.length + 1;
    return {
      ...state,
      newDefalutOrgReportingList: [process, ...state.newDefalutOrgReportingList],
      orgReportingErrorState: 'Please select product group',
    };
  }),

  on(ProjectsActions.deleteOrgYear, (state, { process }) => {
    const deletedRow = cloneDeep(process);
    let filteredData = state.newDefalutOrgReportingList.filter(
      (node: any) => node.index !== deletedRow.index
    );
    filteredData = indexRemapping(filteredData);
    const required = filteredData.filter((data: any) => !data?.id);
    const err = required.length > 0 ? 'Please select product group' : '';
    return {
      ...state,
      newDefalutOrgReportingList: [...filteredData],
      orgReportingErrorState: err,
    };
  }),

  on(ProjectsActions.orgReportingError, (state, { string }) => {
    return {
      ...state,
      orgReportingErrorState: string,
    };
  }),

  on(ProjectsActions.updateOrgYear, (state, { process, action, processIndex, nodeId, colId }) => {
    const editedProcess = cloneDeep(process);
    return produce(state, (draftState: any) => {
      const indx = draftState.newDefalutOrgReportingList.findIndex(
        (x: any) => x.index == editedProcess?.index || editedProcess.data?.index
      );
      if (colId) {
        if (!editedProcess.message && colId !== 'year' && colId !== 'numberofUnitsByYear') {
          draftState.newDefalutOrgReportingList[indx]['productGroupName'] =
            editedProcess?.productGroupName;
        } else if (colId !== 'year') {
          draftState.newDefalutOrgReportingList[indx][colId] = editedProcess[colId];
          draftState.newDefalutOrgReportingList[indx]['id'] =
            editedProcess.id || editedProcess.data?.id;
          draftState.newDefalutOrgReportingList[indx]['packageScenarioId'] =
            editedProcess?.packageScenarioId ||
            editedProcess?.data?.packageScenarioId ||
            editedProcess?.scnearioId;
          draftState.newDefalutOrgReportingList[indx]['numberofUnitsByYear'] =
            editedProcess?.numberofUnitsByYear;
        } else if (colId === 'year') {
          draftState.newDefalutOrgReportingList[indx]['year'] = editedProcess?.id?.id;
          draftState.newDefalutOrgReportingList[indx]['configurationYear'] = editedProcess?.id?.id;
        }
        if (colId === 'checkBox') {
          draftState.newDefalutOrgReportingList[indx]['isCurrentPack'] =
            editedProcess?.isCurrentPack;
        }

        if (colId === 'productgroup') {
          draftState.orgReportingErrorState = '';
          draftState.newDefalutOrgReportingList[indx]['productGroup'] =
            editedProcess?.data?.productGroupId ||
            editedProcess?.data?.productGroup ||
            editedProcess?.productGroupId;
        }
      }
    });
  }),

  on(
    ProjectsActions.updatePackageEOLRetail,
    (state, { process, action, processIndex, nodeId, colId }) => {
      const editedProcessStr: any = localStorage.getItem('retailEOL');
      const editedProcess = JSON.parse(editedProcessStr);

      return produce(state, (draftState: any) => {
        const indx = draftState.packEOLRetailList.findIndex(
          (data: any) => data.index === editedProcess.index
        );
        draftState.packEOLRetailList[indx] = process;
      });
    }
  ),

  on(ProjectsActions.patchEOLRetailDataOnInit, (state, { data }) => {
    const indexedData = data.map((x: any, i: any) => {
      return { ...x, index: i };
    });
    return { ...state, packEOLRetailList: indexedData };
  }),

  on(
    ProjectsActions.updatePackageEOLConsumer,
    (state, { process, action, processIndex, nodeId, colId }) => {
      const editedProcessStr: any = localStorage.getItem('consumerEOL');
      const editedProcess = JSON.parse(editedProcessStr);

      return produce(state, (draftState: any) => {
        const indx = draftState.packEOLConsumerList.findIndex(
          (data: any) => data.index === editedProcess.index
        );
        draftState.packEOLConsumerList[indx] = process;
      });
    }
  ),

  on(ProjectsActions.patchEOLConsumerDataOnInit, (state, { data }) => {
    const indexedData = data.map((x: any, i: any) => {
      return { ...x, index: i };
    });
    return { ...state, packEOLConsumerList: indexedData };
  }),

  on(ProjectsActions.getProductMixListSuccess, (state, { productMixProcess }) => ({
    ...state,
    productMixProcess: productMixProcess,
  })),
  on(ProjectsActions.updateProductMixProcessSuccess, (state, { productMixProcess, error }) => {
    return { ...state, productMixProcess: productMixProcess, productMixProcessError: error };
  }),
  on(ProjectsActions.checkUpdateForProdMix, (state, { check }) => ({
    ...state,
    checkUpdateActionProdMix: check,
  })),
  on(ProjectsActions.checkUpdateActionForOrganizationMapping, (state, { check }) => ({
    ...state,
    checkUpdateActionForOrganizationMapping: check,
  })),
  on(ProjectsActions.checkUpdateActionForInterpretation, (state, { check }) => ({
    ...state,
    checkUpdateActionInterpretation: check,
  })),
  on(ProjectsActions.checkUpdateActionForIngredient, (state, { check }) => ({
    ...state,
    checkUpdateActionIngredient: check,
  })),

  on(ProjectsActions.clearProductMixList, state => {
    return { ...state, productMixProcess: [], productMixProcessError: '' };
  }),

  on(ProjectsActions.clearProductMixError, (state, { errorStr }) => {
    return { ...state, productMixProcessError: errorStr };
  }),

  on(ProjectsActions.fillDataAnalysisListAction, (state, { fillDataAnalysisList }) => {
    return { ...state, dataAnalysisTechnology: fillDataAnalysisList };
  }),

  on(
    ProjectsActions.updateTechnologyInDataAnalysis,
    (state, { process, action, processIndex, nodeId }) => {
      return produce(state, (draftState: any) => {
        draftState.dataAnalysisTechnology[nodeId] = process;
      });
    }
  ),

  on(ProjectsActions.updateComponentErr, (state, { errorStr }) => {
    return { ...state, errorMsgForReuseEOL: errorStr };
  }),

  on(ProjectsActions.clearComponentErr, state => {
    return { ...state, errorMsgForReuseEOL: '' };
  }),
  on(ProjectsActions.checkUpdateActionForReuse, (state, { check }) => ({
    ...state,
    checkUpdateActionForReuse: check,
  }))
);

export function projectsReducer(state: ProjectsState | undefined, action: Action) {
  return reducer(state, action);
}
